// Convert from degrees to radians
export function degreesToRadians(degrees: number): number {
    var radians = (degrees * Math.PI) / 180;
    return radians;
}